import { getApi, postApi } from 'apis';

export const getFnfClearanceList = async (params: Record<string, unknown>) =>
	getApi('/fnf-clearance', params);

export const clearEmployeeFnf = async (data: {
	employeeId: string;
	contractId: string;
	leaveDays: number;
	leaveAmount: number;
	gratuityAmount: number;
}) => postApi('/fnf-clearance/clear', data);
